var webSocket = null;
var globalCallback  = null;  // 定义外部接收数据的回调函数

import store from '@/store/index';
//console.log(store)
// 初始化webSocket
function initWebSocket(url) {
	if(WebSocket !== 'undefined') {
		webSocket = new WebSocket(url);  // 创建socket对象
	}else {
		alert("该浏览器不支持websocket!");
	}
	// 打开socket方法
	webSocket.onopen = function() { 
		ws_open();
	}

	// 接收信息方法
	webSocket.onmessage = function(data) {
		wx_message(data);
	}

	// 关闭方法
	webSocket.onclose = function() {
		console.log('WebSocket连接已关闭')
		// ws_close();
	}

	// 连接错误回调
	webSocket.onerror = function() {
		console.log("WebSocket连接发生错误");
	}
}


// 连接成功方法
function ws_open() {
	// let userId = JSON.parse(sessionStorage.getItem('userId'));
	// if(!userId) return 
	// let objects = {
 //        userId:userId,
 //        systemType:"1",
 //        type: 'msg',
 //    };
 //    sendMsg(objects)
    console.log("WebSocket连接成功！")
}

// 接收服务端消息
function wx_message(res) {
	if(!res)  return;
	const data = JSON.parse(res.data);
	//console.log(globalCallback,callback)
	 // if(globalCallback) {
	 // 	globalCallback(data);//将data传给在外定义的接收数据的函数
	 // }
	 //callback(data);//将data传给在外定义的接收数据的函数
	 store.commit('GET_WEB_SOCKET',data)
}
//发送数据
function webSocketSend(data) {
  webSocket.send(JSON.stringify(data));
}

// 连接关闭
function ws_close() {

	webSocket.close();
	console.log('当前协议地址'+webSocket.url + "已关闭！")
}

// 发送
function sendMsg(data) {
	switch (webSocket.readyState) {
	    //CONNECTING：值为0，表示正在连接。
	    case webSocket.CONNECTING:
	      setTimeout(function() {
	        webSocketSend(data);
	      }, 1000);
	      break;
	    //OPEN：值为1，表示连接成功，可以通信了。
	    case webSocket.OPEN:
	      webSocketSend(data);
	      break;
	    //CLOSING：值为2，表示连接正在关闭。
	    case webSocket.CLOSING:
	      setTimeout(function() {
	        webSocketSend(data);
	      }, 1000);
	      break;
	    //CLOSED：值为3，表示连接已经关闭，或者打开连接失败。
	    case webSocket.CLOSED:
	      // do something
	      break;
	    default:
	      // this never happens
	      break;
	  }
}
export default {
  initWebSocket,
  ws_close,
  sendMsg,
  webSocket
};



// WEBPACK FOOTER //
// ./src/assets/utils/webSocket.js